import * as Sentry from "@sentry/browser";
import { AppConfig } from "../config";

Sentry.init({
  dsn: AppConfig.sentryDsn,
  tracesSampleRate: 1.0,
  enabled: AppConfig.isProduction,
  ignoreErrors: [],
});
